/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

const Advantage = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const photos = [
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/st2.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/slide1.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/slide2.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/slide3.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Box>
      <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
      <Typography
          variant="h4"
          data-aos={'fade-up'}
          gutterBottom
          align='center'
          sx={{
            fontWeight: 700,
          }}
        >
          Alumni 
        </Typography>
        
        <br />
        <Typography variant={'subtitle1'} align='justify'>
        National Public School Yeshwanthpur strives to maintain relations and connections with and amongst its ‘global family’ - Our School Alumni. Good alumni relationships bring many benefits to both the institution and the alumni. We play an important role by representing the views of our members and contributing to building an engaged and supportive alumni community appropriate to a world class Educational Institution with Indian Ethos. We bring to life the brotherhood and the sense of belonging between graduated students who have walked towards their goals. We give our Alumnus a platform to come together, meet and share experiences which otherwise would have been difficult in their busy schedule.
<br/><br/>Over the years, our students have made us proud with their winning streaks in the board exams and have taken up the taste of this enormous success into their future endeavours.
<br/><br/>Presently, our alumni have spread to all segments of life ranging from IT and medicine to fashion designing and from law to theatre. They have certainly carved a niche for themselves and proving to be future ready. Our guiding principle is to ensure that our students go forth out into the wider community empowered with a sense of ambition, confidence and absolute faith in their own innate abilities to pursue and follow the paths they have chosen for themselves.

        </Typography>
        
      </Box>
    </Box>
  );
};

export default Advantage;
